import type { AreaResponse } from 'api/__GENERATED';

// Maps a single Area DTO from the generated API client onto the normalized
// `Data.Area` shape. Only `description` is nullable; everything else is
// guaranteed by the generated zod schema.
function toArea(dto: AreaResponse) {
  const { id, name, description, distributionCenterId, zoneIds } = dto;

  const area: Data.Area = {
    id,
    name,
    description: description ?? '',
    distributionCenterId,
    zoneIds,
  };

  return area;
}

export { toArea };
